import {
  ViewerActionType as PublicViewerActionType,
  ViewerEventType as PublicViewerEventType,
} from "@situm/sdk-js";

import type {
  OnNavigationStartRequestedPayload,
  Route,
} from "../navigation/types";

export interface CartographySelectionOptions {
  fitCamera?: boolean;
}

export enum PosMessageErrorCodes {
  NoNetworkError = "NO_NETWORK_ERROR",
  GenericError = "ERROR",
}

export interface PostMessageErrorPayload {
  code: PosMessageErrorCodes;
  message: string;
  errors?: any;
}

export interface VibratePayload {
  duration: number; // in milliseconds
  intensity: "LOW" | "MEDIUM" | "HIGH";
}

export interface ShareLocationPayload {
  updateInterval:
    | "realtime"
    | "fast"
    | "normal"
    | "slow"
    | "battery_saver"
    | "never";
  durationMinutes: number;
}

export type OnNavigationStartRequestedPayloadToPoint = {
  lat: number;
  lng: number;
  floorIdentifier: string;
  navigationName?: string;
};
export type NavigationStartPayload =
  | OnNavigationStartRequestedPayload
  | OnNavigationStartRequestedPayloadToPoint
  | Route;

// Actions
export enum InternalViewerActionType {
  SHARE_LOCATION_SET_IDENTIFIER = "share_location.set_shared_session_identifier",
  UI_SET_PREFERRED_THEME = "ui.set_preferred_theme",
}

export type ViewerActionType =
  | PublicViewerActionType
  | InternalViewerActionType;

export const ViewerActions = {
  ...PublicViewerActionType,
  ...InternalViewerActionType,
} as const;

// Events
export enum InternalViewerEventType {
  SHARE_LOCATION_STARTED = "share_location.uploading_locations_started",
  SHARE_LOCATION_STOPPED = "share_location.uploading_locations_stopped",
}

export type ViewerEventType = PublicViewerEventType | InternalViewerEventType;

export const ViewerEvents = {
  ...PublicViewerEventType,
  ...InternalViewerEventType,
} as const;
